module.exports = __webpack_public_path__ + "9779d9a1/img/lock-icon.bb9c7166.svg";